import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import cn from 'classnames';
import { SecondaryLink } from '@bibliocommons/base-links';

import './ValuePart.scss';

function linkForSearch(type, query) {
  return `/v2/search?searchType=${type}&query=${encodeURIComponent(query)}`;
}

function formatValue(val, i) {
  return (
    <span className="formatted-value" key={i}>
      {val}
    </span>
  );
}

export default class ValuePart extends React.PureComponent {
  renderContent(values, searchQuery, className) {
    if (values && values.size) {
      const { part, compact, handleClick } = this.props;
      const searchType = part.get('searchType');
      const formattedValues = compact ? values.join(', ') : values.map(formatValue);

      if (searchType && searchQuery) {
        return (
          <SecondaryLink
            className={className}
            href={linkForSearch(searchType, searchQuery)}
            dataKey="value-part-link"
            handleClick={handleClick}
          >
            {formattedValues}
          </SecondaryLink>
        );
      }

      return <span className={className}>{formattedValues}</span>;
    }

    return null;
  }

  render() {
    const { part, className } = this.props;

    if (!part) {
      return null;
    }

    const mainContent = this.renderContent(part.get('values'), part.get('searchQuery'), 'main-content');
    const otherScriptContent = this.renderContent(
      part.get('otherScript'),
      part.get('otherScriptSearchQuery'),
      'other-script-content'
    );

    if (!mainContent && !otherScriptContent) {
      return null;
    }

    const separator = mainContent && otherScriptContent && <span className="separator">•</span>;
    const classNames = cn('cp-value-part', className, { 'with-separator': !!separator });

    return (
      <div className={classNames}>
        {otherScriptContent}
        {separator}
        {mainContent}
      </div>
    );
  }
}

ValuePart.propTypes = {
  className: PropTypes.string,
  part: ImmutablePropTypes.map,
  compact: PropTypes.bool,
  handleClick: PropTypes.func
};
